import { getMunicipalManagers } from 'api/forms/pacote_formularios.api';
import { create } from 'zustand';

interface IMunicipalManager {
    name: string;
}

export interface IMunicipalManagersStore {
    municipalManagers: IMunicipalManager[];
    setMunicipalManagers: (municipalManagers: IMunicipalManager[]) => void;
    getMunicipalManagers: () => void;
}
const useMunicipalManagersStore = create<IMunicipalManagersStore>((set) => ({
    municipalManagers: [],
    setMunicipalManagers: (municipalManagers) => set({ municipalManagers }),
    getMunicipalManagers: async () => {
        const response = await getMunicipalManagers();
        set({ municipalManagers: response.dados });
    }
}))

export default useMunicipalManagersStore;